// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"60258e87","977":"26c86326"}[chunkId] + ".chunk.js";
};